import { update, merge, __ } from 'lodash/fp';
import { createReducer } from '@mews/framework';
import {
    META_STATE_STARTED,
    META_STATE_FAILED,
    META_STATE_SUCCEEDED,
} from '@mews-commander/legacy-entities/src/constants';
import { OCCUPANCY_FETCHING_FAILED, OCCUPANCY_FETCHING_STARTED, OCCUPANCY_FETCHING_SUCCEEDED } from './actions';

export default createReducer(
    { ...META_STATE_SUCCEEDED },
    {
        [OCCUPANCY_FETCHING_STARTED]: (state: $TSFixMe, { serviceId, startUtc, endUtc }: $TSFixMe) =>
            update([serviceId, startUtc, endUtc], merge(__, { ...META_STATE_STARTED }))(state),
        [OCCUPANCY_FETCHING_FAILED]: (state: $TSFixMe, { serviceId, startUtc, endUtc }: $TSFixMe) =>
            update([serviceId, startUtc, endUtc], merge(__, { ...META_STATE_FAILED }))(state),
        [OCCUPANCY_FETCHING_SUCCEEDED]: (state: $TSFixMe, { serviceId, startUtc, endUtc, data }: $TSFixMe) =>
            update([serviceId, startUtc, endUtc], merge(__, { ...META_STATE_SUCCEEDED, data }))(state),
    }
);
